function devtricker_dom_set_showSpinnerOnUserImage() {

    const container = document.querySelector('.header-user-image');
    const notificationBadge = document.getElementById("notificationBadge");

    if (container) {
        container.innerHTML = '<div class="spinner-border text-secondary" role="status" style="width: 32px; height: 32px;"><span class="visually-hidden"></span></div>';
    }

    if (notificationBadge) {
        notificationBadge.classList.add('d-none');
    }
}

function devtricker_dom_get_logoutButton() {
    return document.getElementById('logout-link');
}